import { render, staticRenderFns } from "./DuplicateBizoppCheckbox.vue?vue&type=template&id=483ad68b&"
import script from "./DuplicateBizoppCheckbox.vue?vue&type=script&lang=js&"
export * from "./DuplicateBizoppCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports